import {
  GET_TRANSACTION_HISTORY,
  SET_ORDERS_PROP,
  IMPORT_BASKET,
  LIST_PAYMENT_CARDS,
  ADD_PAYMENT_CARD,
  REMOVE_PAYMENT_CARD,
  CREATE_ORDER,
  GET_ORDER_HISTORY,
  ADD_SCANNED_CARD,
  SET_DELIVERY_ADDRESS,
  POSTCODE_CHECK,
  SET_POSTCODE_DATA,
  GET_NEAREST_LOCATION,
  LOCATION_CODE_CHECK,
  SET_LOCATION_CODE_DATA,
  ADD_PICKUP_POINT,
  SET_PICK_UP_POINT,
  ADD_DELIVERY_ADDRESS,
  REMOVE_DELIVERY_ADDRESS,
  CHECK_CANCEL_ORDER,
  STORE_ITEM_WEB,
  UPDATE_PAYMENT_INFO,
  SEND_GIFT_VOUCHER,
  REDEEM_GIFT_VOUCHER,
  CLEAR_GIFT_VOUCHER_DATA,
  GET_SENT_GIFT_VOUCHERS,
  RESEND_GIFT_VOUCHER,
  UPDATE_GIFT_VOUCHER,
  CREATE_PREBUILD_PAYMENT_ORDER,
  CREATE_YOCO_ORDER,
  BOOK_DELIVERY_DRIVER,
  SET_BILL_STATUS,
  SEND_TABLE_BILL,
  SEND_TABLE_PAYMENT_EMAIL,
  SELECT_TABLE_ITEM,
  SET_TABLE_PAY_METHOD,
  BOOK_UBER_DRIVER,
  CREATE_SQUARE_ORDER,
  SAVE_SQUARE_PAYMENT_CARD,
  CREATE_CHECKOUT_PAYMENT_ORDER,
  GET_EVENTS,
  SET_EVENTS,
  GET_EVENT_CATEGORIES,
  SET_EVENT_CATEGORIES,
  GET_EVENT,
  SET_EVENT,
  GET_MY_EVENTS_CURRENT,
  SET_MY_EVENTS_CURRENT,
  GET_MY_EVENTS_UPCOMING,
  SET_MY_EVENTS_UPCOMING,
  GET_MY_EVENTS_HISTORY,
  SET_MY_EVENTS_HISTORY,
  GET_EVENT_TICKET,
  SET_EVENT_TICKET,
  TRANSFER_EVENT_TICKET,
  PURCHASE_EVENT,
  SET_EVENT_PURCHASE,
  GET_CURATED_MENUS,
  GET_CURATED_MENU
} from './constants';
import { UPDATE_PROFILE, GET_PROFILE } from '../constants';
import { take, call, put, select, takeLatest, delay, fork, race } from 'redux-saga/effects';
import { loading } from '../common/sagas';
import api from '../../lib/api';
import Basket from '../../lib/basket';
import { getConfig } from '../../appConfig';
import { getPaymentCards, showToast, updateDriverCountdown } from '../actions';
import { isDefined, forwardTo, isEmptyObject, validateForm, getOrderTypeMenus,verifySquareBuyerNative } from '../../lib/utils';
import { translateSaga } from '../common/sagas';
import LibStripe from '../../lib/stripe';
import { GET_VOUCHERS } from '../profile/constants';
import { SET_COMMON_MODAL, SET_COMMON_PROP } from '../common/constants';
import { SET_RESTAURANT_PROP, SET_TABLE_DATA } from '../restaurants/constants';
import { filterMenu, getRestaurantsWorker } from '../restaurants/sagas';
import { getEffectiveAvailability, isStoreOpened } from '../../screens/clickAndCollect';
import { Browser } from '@capacitor/browser';
import asyncStorage from '../../lib/asyncStorage';
import { getEnv } from '../../lib/env';
import { InAppBrowser } from '@capgo/capacitor-inappbrowser'
import moment from '../../lib/moment';
import { CapSquarePayments } from 'cap-square-payment';
import { CapCheckoutPayments } from 'cap-checkout-payment';

const isWeb = () => Capacitor.getPlatform() === 'web';

/* transaction history Saga */
export const getTransactionHistoryFlow = function* () {
  while (!getConfig().flags) {
    yield delay(100);
  }
  const { hasOrdering, hasLoyalty, disableHistoryPagination } = getConfig().flags;
  while (true) {
    const { page, skipOrders, skipLoyalty } = yield take(GET_TRANSACTION_HISTORY);
    const paginationPage = disableHistoryPagination ? null : page;

    yield call(loading, function* () {
      // call transaction and order history
      if (hasOrdering && !skipOrders) {
        yield call(getOrderHistoryData, paginationPage);
      }
      if (hasLoyalty && !skipLoyalty) {
        const history = yield call(api.getHistory, paginationPage);
        yield put({ type: SET_ORDERS_PROP, key: 'history', value: history });
      }
    });
  }
};

export const importBasket = function* () {
  while (true) {
    yield take(IMPORT_BASKET);
    yield call(Basket.import);
  }
};

export const getPaymentCardsFlow = function* () {
  while (true) {
    yield take(LIST_PAYMENT_CARDS);
    const store = yield select();
    if (store?.profile?.auth?.loggedIn) {
      yield call(loading, function* () {
        const cards = yield call(api.getPaymentCards);
        yield put({ type: SET_ORDERS_PROP, key: 'cards', value: cards });
      });
    }
  }
};

export const addPaymentCardsFlow = function* () {
  while (true) {
    const action = yield take(ADD_PAYMENT_CARD);
    const { name, options } = action;
    let result = null;
    if (getConfig().payment === 'judopay') {
      options['name'] = name;
      yield call(loading, function* () {
        try {
          const savedCards = yield call(api.saveJudoPayCard, options);
          yield put({ type: SET_ORDERS_PROP, key: 'cards', value: savedCards });
          yield put(showToast(yield call(translateSaga, 'Card added successfully'), 'success'));

          yield put({ type: GET_PROFILE });
          if (options.cb) {
            yield call(options.cb);
          }
        } catch (e) {
          yield put(showToast(yield call(translateSaga, 'Problem adding card'), 'warning'));
          throw e;
        }
      });
    } else {
      if (options.stripe) {
        result = yield call(options.stripe.createToken);
      }
      yield call(loading, function* () {
        if (options.stripe) {
          try {
            if (result.error) {
              yield put(showToast(yield call(translateSaga, result.error.message), 'warning'));
            } else {
              const payment_token = result.token.id;

              const savedCards = yield call(api.addPaymentCard, { payment_token, name });
              yield put({ type: SET_ORDERS_PROP, key: 'cards', value: savedCards });
              yield put(showToast(yield call(translateSaga, 'Card added successfully'), 'success'));

              //everytime when user add card that card will be default card. Because of that we call get profile
              yield put({ type: GET_PROFILE });

              if (options.cb) {
                yield call(options.cb);
              }
            }
          } catch (e) {
            yield put(showToast(yield call(translateSaga, 'Problem adding card'), 'warning'));
            throw e;
          }
        }
      });
    }
  }
};

export const addScannedCard = function* () {
  while (true) {
    const action = yield take(ADD_SCANNED_CARD);
    yield call(loading, function* () {
      const { options, payment_token, name } = action;
      const savedCards = yield call(api.addPaymentCard, { payment_token, name });
      yield put({ type: SET_ORDERS_PROP, key: 'cards', value: savedCards });
      yield put(showToast('Card added successfully', 'success'));

      //everytime when user add card that card will be default card. Because of that we call get profile
      yield put({ type: GET_PROFILE });
      if (options.cb) {
        yield call(options.cb);
      }
    });
  }
};

export const removePaymentCardsFlow = function* () {
  while (true) {
    const action = yield take(REMOVE_PAYMENT_CARD);
    yield call(loading, function* () {
      const { cardToken, options } = action;

      const data = {
        payment_token: cardToken,
      };
      const result = yield call(api.removePaymentCard, data);
      if (result.error) {
        yield put(showToast(yield call(translateSaga, result.error.message), 'warning'));
      } else {
        yield put({ type: SET_ORDERS_PROP, key: 'cards', value: result.data });
        yield put(showToast(yield call(translateSaga, 'Card removed successfully'), 'success'));
      }
      if (options.cb) {
        yield call(options.cb);
      }

      const store = yield select();
      if (
        store.profile &&
        store.profile.profile &&
        store.profile.profile.cardToken &&
        store.profile.profile.cardToken === cardToken
      ) {
        // If the user want to delete default card then change default card to the first one.
        // When user delete last card then put null
        yield put({
          type: UPDATE_PROFILE,
          skipAlert: true,
          data: {
            cardToken:
              store.orders.cards && store.orders.cards.length > 0 ? store.orders.cards[0].id : null,
          },
        });
      }
    });
  }
};

const checkIntentResult = function* (intentResult) {
  // Stripe.checkIntentResult i maybe already called
  const status = isDefined(intentResult.isValid) ? intentResult : yield call(Stripe.checkIntentResult, intentResult);
  if (status.isValid) {
    yield put(showToast(status.message, 'success'));
  } else {
    yield put(showToast(status.message, 'warning'));
  }
  return status;
};


const updatePaymentInfo = function* (intentResult, paymentType, createdOrder) {
  const paymentInfo = {
    intentResult,
    paymentMethod: paymentType,
    orderId: createdOrder.id,
  };
  yield put({ type: UPDATE_PAYMENT_INFO, paymentInfo });
};

// the event purchase payload is rebuilt from the basket items, which carry their
// tier ids - it has to be captured before resetBasket() empties the basket
const getEventOrderData = () => {
  if (!Basket.isEvent()) {
    return null;
  }
  const tickets = Basket.getItems().filter(
    (basketItem) => basketItem.item?.ticket_tier_id && basketItem.item?.event_id,
  );
  if (tickets.length === 0) {
    return null;
  }
  return {
    event_id: tickets[0].item.event_id,
    items: tickets.map((basketItem) => ({
      tier_id: basketItem.item.ticket_tier_id,
      quantity: basketItem.quantity,
    })),
    tip: 0,
  };
};

const resetBasket = (giftVoucherData = false, billPay = false, eventOrderData = false) => {
  if (!billPay) {
    Basket.reset();
  }
  // vouchers and event tickets navigate from their own follow-up saga once the
  // ticket/voucher has actually been issued, so don't forward here
  if (!giftVoucherData && !billPay && !eventOrderData) {
    forwardTo('/order-completed', { completedOrder: true });
  }
  if (billPay) {
    forwardTo('/bill-completed', { completedOrder: true });
  }
};
const createPrebuildPaymentOrderFlow = function* (action) {
  yield call(Browser.removeAllListeners);
  const { paymentType, paymentWebType, cb } = action
  const store = yield select();
  const giftVoucherData = store.orders.giftVoucherData;
  yield call(loading, function* () {
    if (moment().isAfter(moment(Basket.uber_expiry)) && getConfig().flags.hasUberDriverBooking && Basket.order_type.includes('delivery')) {
      const success = yield call(bookUberDriverWorker);
      if (!success) {
        return
      }
    }
    let orderData = Basket.parseBasketData(paymentType, paymentWebType);
    const store = yield select();
    if (getConfig().general.validationConfig?.mobile && store?.profile?.auth?.loggedIn && !orderData.is_gift && !orderData.is_event) {
      const mobileValid = isEmptyObject(validateForm({ mobile: { required: true, type: 'tel' } }, { mobile: orderData.mobile }))
      if (getConfig().flags.hasMobileCountryCode) {
        if (orderData.mobile == orderData.mobile_code || !orderData.mobile || orderData.mobile == '' || !mobileValid) {
          forwardTo('/order-summary', { mobileInvalid: true })
          return
        }
      } else {
        if (!orderData.mobile || orderData.mobile == '' || !mobileValid) {
          forwardTo('/order-summary', { mobileInvalid: true })
          return
        }
      }
    }
    if (!orderData.table_name && Basket.order_type.toLowerCase() == 'table') {
      yield put({ type: SET_COMMON_PROP, key: 'tableNumberModalOpened', value: true });
      yield take('CONFIRM_TABLE_NUMBER');
      const tableNumber = Basket.getTableNumber();
      orderData.table_name = tableNumber;
    }
    orderData.paymentToken = store.orders.paymentToken ? store.orders.paymentToken : null;
    //create order and init stripe intent
    const result = yield call(api.createPrebuildPaymentOrder, orderData);
    Basket.rotateUUID();
    if (giftVoucherData) {
      giftVoucherData.order_id = result.data.order.id;
    }
    // process payment intent
    if (result.data?.error || result.error) {
      if (result.data?.type === 'insufficient_stock') {
        if (result?.data?.items.length > 0) {
          yield put({ type: SET_COMMON_MODAL, modal: 'insuficientStockModalOpened', value: true });
          Basket.setInsuficientStockData(result?.data?.items)
        }
      } else if (result.data?.type === 'order-type-unavailable') {
        yield put(showToast(result.data?.message || 'This order type is currently unavailable at this location.', 'warning'));
        if (Basket.has_multi_basket && result.data?.closed_restaurants?.length > 0) {
          const closedIds = result.data.closed_restaurants.map((r) => r.id);
          const allVenuesClosed = Basket.multi_basket_items.every((group) => closedIds.includes(group.restaurant.id));
          if (allVenuesClosed) {
            Basket.reset();
            forwardTo('/delivery-options');
          } else {
            Basket.removeRestaurantItems(closedIds);
            forwardTo('/order-summary');
          }
        } else {
          Basket.reset();
          forwardTo('/delivery-options');
        }
      }
      else if (result.data?.type === 'is_collection_time_available') {
        const restaurants = yield call(api.getRestaurants);
        yield put({
          type: SET_RESTAURANT_PROP,
          key: 'restaurants',
          value: restaurants,
        });
        yield put({
          type: SET_COMMON_MODAL,
          modal: 'deliveryTimeModalOpen',
          value: true,
        });
      } else {
        yield put(showToast('Order create error', 'warning'));
      }
    } else {
      if (result.data.checkout) {
        if (isWeb() || getConfig()?.prebuildPayment?.useNativeBrowser) {
          window.open(result.data.checkout.url, '_self');
        } else {
          InAppBrowser.addListener("urlChangeEvent", async (event) => {
            console.log("[InAppBrowser] urlChangeEvent:", Date.UTC());
            if (event?.url?.includes('order-status')) {
              await InAppBrowser.close();
              Basket.reset();
              forwardTo('/order-completed');
            }
          });
          InAppBrowser.addListener("buttonNearDoneClick", (event) => {
            console.log("[InAppBrowser] buttonNearDoneClick:", Date.UTC());
          });
          InAppBrowser.addListener("closeEvent", async (event) => {
            await api.removeRedemtionsFromVouchers();
          });
          InAppBrowser.addListener("confirmBtnClicked", (event) => {
            console.log("[InAppBrowser] confirmBtnClicked:", Date.UTC());
          });
          InAppBrowser.addListener("messageFromWebview", async (event) => {
            console.log("[InAppBrowser] messageFromWebview:", Date.UTC());
            await InAppBrowser.close();
            Basket.reset();
            forwardTo('/order-completed');
          });
          InAppBrowser.addListener("browserPageLoaded", () => {
            console.log("[InAppBrowser] browserPageLoaded");
          });
          InAppBrowser.addListener("pageLoadError", () => {
            console.log("[InAppBrowser] pageLoadError");
          });
          yield call(InAppBrowser.openWebView, {
            url: result.data.checkout.url,
            title: "Checkout",
            activeNativeNavigationForWebview: true,
            showReloadButton: false,
            toolbarType: "COMPACT"
          });
        }
      } else {
        Basket.reset();
        yield call(getOrderHistoryData, page);
        forwardTo('/order-completed');
      }
    }
  });
};

const waitForBrowserFinished = () =>
  new Promise((resolve) => {
    Browser.addListener('browserFinished', () => resolve(true));
  });

const createYocoOrderFlow = function* (action) {
  const { paymentType, paymentWebType, cb } = action
  const store = yield select();
  const { disableHistoryPagination } = getConfig()?.flags;
  const page = disableHistoryPagination ? null : 1;
  const giftVoucherData = store.orders.giftVoucherData;
  let nativeYocoOrderId = null;
  yield call(loading, function* () {
    if (moment().isAfter(moment(Basket.uber_expiry)) && getConfig().flags.hasUberDriverBooking && Basket.order_type.includes('delivery')) {
      const success = yield call(bookUberDriverWorker);
      if (!success) {
        return
      }
    }
    let orderData = Basket.parseBasketData(paymentType, paymentWebType);
    const store = yield select();
    if (getConfig().general.validationConfig?.mobile && store?.profile?.auth?.loggedIn && !orderData.is_gift && !orderData.is_event) {
      const mobileValid = isEmptyObject(validateForm({ mobile: { required: true, type: 'tel' } }, { mobile: orderData.mobile }))
      if (getConfig().flags.hasMobileCountryCode) {
        if (orderData.mobile == orderData.mobile_code || !orderData.mobile || orderData.mobile == '' || !mobileValid) {
          forwardTo('/order-summary', { mobileInvalid: true })
          return
        }
      } else {
        if (!orderData.mobile || orderData.mobile == '' || !mobileValid) {
          forwardTo('/order-summary', { mobileInvalid: true })
          return
        }
      }
    }
    if (!orderData.table_name && Basket.order_type.toLowerCase() == 'table') {
      yield put({ type: SET_COMMON_PROP, key: 'tableNumberModalOpened', value: true });
      yield take('CONFIRM_TABLE_NUMBER');
      const tableNumber = Basket.getTableNumber();
      orderData.table_name = tableNumber;
    }
    orderData.paymentToken = store.orders.paymentToken ? store.orders.paymentToken : null;
    //create order and init stripe intent
    const result = yield call(api.createYocoOrder, orderData);
    Basket.rotateUUID();
    if (giftVoucherData) {
      giftVoucherData.order_id = result.data.order.id;
    }
    // process payment intent
    if (result.data?.error || result.error) {
      if (result.data?.type === 'insufficient_stock') {
        if (result?.data?.items.length > 0) {
          yield put({ type: SET_COMMON_MODAL, modal: 'insuficientStockModalOpened', value: true });
          Basket.setInsuficientStockData(result?.data?.items)
        }
      }
      else if (result.data?.type === 'order-type-unavailable') {
        yield put(showToast(result.data?.message || 'This order type is currently unavailable at this location.', 'warning'));
        if (Basket.has_multi_basket && result.data?.closed_restaurants?.length > 0) {
          const closedIds = result.data.closed_restaurants.map((r) => r.id);
          const allVenuesClosed = Basket.multi_basket_items.every((group) => closedIds.includes(group.restaurant.id));
          if (allVenuesClosed) {
            Basket.reset();
            forwardTo('/delivery-options');
          } else {
            Basket.removeRestaurantItems(closedIds);
            forwardTo('/order-summary');
          }
        } else {
          Basket.reset();
          forwardTo('/delivery-options');
        }
      }
      else if (result.data?.type === 'is_collection_time_available') {
        const restaurants = yield call(api.getRestaurants);
        yield put({
          type: SET_RESTAURANT_PROP,
          key: 'restaurants',
          value: restaurants,
        });
        yield put({
          type: SET_COMMON_MODAL,
          modal: 'deliveryTimeModalOpen',
          value: true,
        });
      } else {
        yield put(showToast('Order create error', 'warning'));
      }
    } else {
      if (result.data.yoco) {
        if (isWeb()) {
          if (!result.data.yoco.error) {
            window.open(result.data.yoco.redirectUrl, '_self');
          } else if (result.data.yoco.redirectUrl) {
            yield put(showToast(result.data.yoco.error, 'warning'));
          }
        } else {
          if (!result.data.yoco.error) {
            yield call(Browser.removeAllListeners);
            yield call(Browser.open, { url: result.data.yoco.redirectUrl, toolbarColor: "#ffffff", presentationStyle: 'popover', windowName: '_self' });
            nativeYocoOrderId = result.data.order?.id || null;
          } else {
            yield put(showToast(result.data.yoco.error, 'warning'));
          }
        }
      } else {
        Basket.reset();
        yield call(getOrderHistoryData, page);
        forwardTo('/order-completed');
      }
    }
  });

  if (!nativeYocoOrderId) {
    return;
  }
  // Native: Yoco's success page redirects to our /order-status URL. Android app links open the
  // app on that redirect, but iOS universal links only fire on a user tap, so on iOS the app is
  // never told about the payment. Wait for either the webhook to mark the order paid or the user
  // to close the browser, then confirm with the backend before completing the order.
  const raceResult = yield race({
    settled: call(pollCheckoutOrderStatus, nativeYocoOrderId, 300),
    closed: call(waitForBrowserFinished),
  });
  yield call(Browser.removeAllListeners);
  let pollResult = raceResult.settled?.result;
  if (!raceResult.settled) {
    yield call(loading, function* () {
      ({ result: pollResult } = yield call(pollCheckoutOrderStatus, nativeYocoOrderId, 3));
    });
  }
  if (pollResult === 'paid') {
    try {
      yield call(Browser.close);
    } catch (e) {
      // Browser already closed
    }
    Basket.reset();
    yield call(getOrderHistoryData, page);
    forwardTo('/order-completed');
  }
};
const createOrderFlow = function* (action) {
  const { paymentType, paymentWebType, cb } = action
  const store = yield select();
  const giftVoucherData = store.orders.giftVoucherData;
  const eventOrderData = getEventOrderData();

  yield call(loading, function* () {
    if (moment().isAfter(moment(Basket.uber_expiry)) && getConfig().flags.hasUberDriverBooking && Basket.order_type.includes('delivery')) {
      const success = yield call(bookUberDriverWorker);
      if (!success) {
        return
      }
    }
    let orderData = Basket.parseBasketData(paymentType, paymentWebType);
    const store = yield select();
    if (getConfig().general.validationConfig?.mobile && store?.profile?.auth?.loggedIn && !orderData.is_gift && !orderData.is_event) {
      const mobileValid = isEmptyObject(validateForm({ mobile: { required: true, type: 'tel' } }, { mobile: orderData.mobile }))
      if (getConfig().flags.hasMobileCountryCode) {
        if (orderData.mobile == orderData.mobile_code || !orderData.mobile || orderData.mobile == '' || !mobileValid) {
          forwardTo('/order-summary', { mobileInvalid: true })
          return
        }
      } else {
        if (!orderData.mobile || orderData.mobile == '' || !mobileValid) {
          forwardTo('/order-summary', { mobileInvalid: true })
          return
        }
      }
    }
    if (!orderData.table_name && Basket.order_type.toLowerCase() == 'table') {
      yield put({ type: SET_COMMON_PROP, key: 'tableNumberModalOpened', value: true });
      yield take('CONFIRM_TABLE_NUMBER');
      const tableNumber = Basket.getTableNumber();
      orderData.table_name = tableNumber;
    }
    orderData.paymentToken = store.orders.paymentToken ? store.orders.paymentToken : null;
    //create order and init stripe intent
    let result;

    if (paymentType === 'NativePayment') {
      orderData.payment_token = 'Card';
      result = yield call(api.createStripeOrderNative, orderData);
    } else {
      result = yield call(api.createOrder, orderData);
    }
    Basket.rotateUUID();
    if (giftVoucherData) {
      giftVoucherData.order_id = result.data.order.id;
    }
    if (eventOrderData) {
      // ties the issued tickets back to the order that was actually paid for
      eventOrderData.order_id = result.data.order.id;
    }
    yield put({ type: GET_VOUCHERS });
    // SPRIN-486: a same-UUID retry is replayed by the backend instead of creating
    // a new order ("Order already created." is never returned any more)
    if (result.data?.idempotent_replay) {
      const replayStatus = result.data.existing_payment_status;
      if (replayStatus === 'PAID') {
        // the original attempt already got charged - just finish the flow
        yield call(resetBasket, giftVoucherData, false, eventOrderData);
        if (giftVoucherData) {
          yield put({ type: SEND_GIFT_VOUCHER, data: giftVoucherData });
        }
        if (eventOrderData) {
          yield put({ type: PURCHASE_EVENT, data: eventOrderData });
        }
        return;
      }
      if (replayStatus === 'FAILED') {
        // the original attempt is terminally failed - mint a fresh UUID so the
        // next tap starts a clean attempt
        const uuid = `${store?.profile?.profile?.id}_${Date.now()}`;
        Basket.setUUID(uuid, true);
        yield put(showToast('Your previous payment attempt did not complete. Please try again.', 'warning'));
        return;
      }
      // PENDING: the response carries the original order and its client_secret,
      // so the normal flow below re-presents the same payment to be finished
    }
    // process payment intent
    if (result.data?.error || result.error || !result.data) {
      if (result.data?.type === 'insufficient_stock') {
        if (result?.data?.items.length > 0) {
          yield put({ type: SET_COMMON_MODAL, modal: 'insuficientStockModalOpened', value: true });
          Basket.setInsuficientStockData(result?.data?.items)
        }
      }
      else if (result.data?.type === 'order-type-unavailable') {
        yield put(showToast(result.data?.message || 'This order type is currently unavailable at this location.', 'warning'));
        if (Basket.has_multi_basket && result.data?.closed_restaurants?.length > 0) {
          const closedIds = result.data.closed_restaurants.map((r) => r.id);
          const allVenuesClosed = Basket.multi_basket_items.every((group) => closedIds.includes(group.restaurant.id));
          if (allVenuesClosed) {
            Basket.reset();
            forwardTo('/delivery-options');
          } else {
            Basket.removeRestaurantItems(closedIds);
            forwardTo('/order-summary');
          }
        } else {
          Basket.reset();
          forwardTo('/delivery-options');
        }
      } else if (result.data?.type === 'collection-time') {
        const restaurants = yield call(api.getRestaurants);
        yield put({
          type: SET_RESTAURANT_PROP,
          key: 'restaurants',
          value: restaurants,
        });
        yield put({ type: SET_COMMON_MODAL, modal: 'deliveryTimeModalOpen', value: true });
      } else {
        yield put(showToast('Order create error', 'warning'));
      }
    } else if (paymentType === 'collectedPay' || paymentType == 'driverPay') {
      const createdOrder = result.data.order;
      const store = yield select();
      yield put({
        type: SET_ORDERS_PROP,
        key: 'orderHistory',
        value: [createdOrder, ...(store.orders.orderHistory || [])],
      });
      yield call(resetBasket);
    } else {
      const createdOrder = result.data.order;
      const clientSecret = result.data.client_secret;
      if (!clientSecret || clientSecret === '') {
        yield put(showToast('Payment error.', 'danger'));
      } else {
        if (getConfig().payment === 'judopay') {
          if (clientSecret.result && clientSecret.result === 'Declined') {
            yield put(showToast('Payment error.\n' + (clientSecret.message || ''), 'danger'));
          } else {
            yield call(resetBasket, giftVoucherData, false, eventOrderData);
            if (giftVoucherData) {
              yield put({
                type: SEND_GIFT_VOUCHER,
                data: giftVoucherData,
              });
            }
            if (eventOrderData) {
              yield put({ type: PURCHASE_EVENT, data: eventOrderData });
            }
          }
        } else {
          if (clientSecret === '-1') {
            // total for order is: 0
            yield call(checkIntentResult, {
              status: 'succeeded',
              isValid: true
            });
            yield call(resetBasket, giftVoucherData, false, eventOrderData);
            if (giftVoucherData) {
              yield put({
                type: SEND_GIFT_VOUCHER,
                data: giftVoucherData,
              });
            }
            if (eventOrderData) {
              yield put({ type: PURCHASE_EVENT, data: eventOrderData });
            }
          } else if (paymentType === 'webPayment') {
            yield put({ type: SET_ORDERS_PROP, key: 'clientSecret', value: clientSecret });
            if (cb) {
              yield call(cb, clientSecret, resetBasket, giftVoucherData, eventOrderData);
            }
          } else {
            try {
              let intentResult;
              if (paymentType === 'google') {
                // pay with google pay
                intentResult = yield call(
                  LibStripe.payWithGooglePay,
                  clientSecret,
                  orderData._total,
                );
                yield call(updatePaymentInfo, intentResult, paymentType, createdOrder);
                const checkedIntentResult = yield call(checkIntentResult, intentResult);
                if (checkedIntentResult.isValid) {
                  if (giftVoucherData) {
                    yield put({
                      type: SEND_GIFT_VOUCHER,
                      data: giftVoucherData,
                    });
                  }
                  if (eventOrderData) {
                    yield put({ type: PURCHASE_EVENT, data: eventOrderData });
                  }
                  yield call(resetBasket, giftVoucherData, false, eventOrderData);
                }
              } else if (paymentType === 'apple') {
                // pay with apple pay
                const store = yield select();
                intentResult = yield call(
                  LibStripe.payWithApplePay,
                  clientSecret,
                  store.profile.profile,
                );
                yield call(updatePaymentInfo, intentResult, paymentType, createdOrder);
                const checkedIntentResult = yield call(checkIntentResult, intentResult);


                yield call(resetBasket, giftVoucherData, false, eventOrderData);

                if (giftVoucherData && checkedIntentResult.isValid) {
                  yield put({
                    type: SEND_GIFT_VOUCHER,
                    data: giftVoucherData,
                  });
                }
                if (eventOrderData && checkedIntentResult.isValid) {
                  yield put({ type: PURCHASE_EVENT, data: eventOrderData });
                }
              } else if (paymentType === 'NativePayment') {
                const store = yield select();
                const uuid = `${store?.profile?.profile?.id}_${Date.now()}`;
                try {
                  const nativePayment = getConfig().nativePayment || {};
                  const merchantDisplayName = nativePayment.merchantDisplayName || "";
                  const merchantCountryCode = nativePayment.merchantCountryCode || 'GB';
                  const withZipCode = nativePayment.withZipCode || false;
                  const enableGooglePay = nativePayment.enableGooglePay || false;
                  const googlePayIsTesting = nativePayment.googlePayIsTesting || false;
                  const enableApplePay = nativePayment.enableApplePay || false;
                  const applePayMerchantId = nativePayment.applePayMerchantId || ''
                  const stripeInstance = LibStripe.getStripeInstance();
                  const customerId = result.data?.customer_id;
                  const customerEphemeralKeySecret = result.data?.ephemeral_key;
                  yield stripeInstance.createPaymentSheet({
                    GooglePayIsTesting: googlePayIsTesting,
                    paymentIntentClientSecret: clientSecret,
                    merchantDisplayName,
                    merchantCountryCode,
                    withZipCode,
                    enableGooglePay,
                    enableApplePay,
                    applePayMerchantId,
                    customerId,
                    customerEphemeralKeySecret
                  });
                  const { paymentResult } = yield stripeInstance.presentPaymentSheet();
                  if (paymentResult === 'paymentSheetCompleted') {
                    yield call(resetBasket, giftVoucherData, false, eventOrderData);
                    if (giftVoucherData) {
                      yield put({
                        type: SEND_GIFT_VOUCHER,
                        data: giftVoucherData,
                      });
                    }
                    if (eventOrderData) {
                      yield put({ type: PURCHASE_EVENT, data: eventOrderData });
                    }
                  } else {
                    Basket.setUUID(uuid, true);
                  }
                } catch (ex) {
                  console.log('Error ', ex);
                  Basket.setUUID(uuid, true);
                }

              } else {
                // pay with regular payment card
                let intentResult = null;
                if (isWeb()) {
                  intentResult = yield call(LibStripe.confirmPaymentIntent, clientSecret, {
                    paymentMethodId: orderData.payment_token,
                  });
                  const checkedIntentResult = yield call(checkIntentResult, intentResult);
                  if (checkedIntentResult.isValid) {
                    yield call(resetBasket, giftVoucherData, false, eventOrderData);
                  }
                  // SPRIN-486: on a failed intent the UUID is kept so a retry is
                  // replayed against the same order and PaymentIntent by the backend
                  if (giftVoucherData && checkedIntentResult.isValid) {
                    yield put({
                      type: SEND_GIFT_VOUCHER,
                      data: giftVoucherData,
                    });
                  }
                  if (eventOrderData && checkedIntentResult.isValid) {
                    yield put({ type: PURCHASE_EVENT, data: eventOrderData });
                  }
                } else {
                  intentResult = yield call(api.confirmPaymentIntentNative, { intent_id: result?.data?.intent_id, payment_token: orderData.payment_token })
                  if (intentResult && intentResult?.data?.confirmedPaymentIntent?.next_action?.use_stripe_sdk?.stripe_js) {
                    yield call(Browser.open, {
                      url: intentResult?.data?.confirmedPaymentIntent?.next_action?.use_stripe_sdk?.stripe_js,
                      toolbarColor: "#ffffff",
                      presentationStyle: 'popover',
                      windowName: '_self'
                    });
                    /* Browser.addListener('browserFinished', () => {
                      forwardTo('/order-completed');
                    }); */
                  }
                }
              }
              // yield call(resetBasket);
              // if (isDefined(intentResult) && intentResult.isValid) {
              //   createdOrder.amount_paid = intentResult.intentResult.amount;
              // }
            } catch (e) {
              yield put(showToast('Payment error.\n' + (e.message || ''), 'danger'));
            }
          }
        }
      }

      //update ordr history with new added order
      const store = yield select();
      createdOrder.order_value = orderData.total;
      yield put({
        type: SET_ORDERS_PROP,
        key: 'orderHistory',
        value: [createdOrder, ...(store.orders.orderHistory || [])],
      });
    }
  });
};

// Saves a new Square card without placing an order. Used when 3D Secure is on: the buyer verifies
// the card while adding it, then pays with it from the saved cards list.
const saveSquarePaymentCardFlow = function* (action) {
  const { cardData, options } = action;
  yield call(loading, function* () {
    try {
      const savedCard = yield call(api.createSquarePaymentCard, cardData);
      yield put(getPaymentCards());
      if (options.cb) {
        yield call(options.cb, savedCard);
      }
    } catch (error) {
      console.error('Square Pay Error:', error?.response?.data);
      yield put(showToast(error?.response?.data?.error?.message || 'Error adding payment card.', 'danger'));
    }
  });
};

const createSquareOrderFlow = function* (action) {
  const {
    paymentType,
    paymentWebType,
    saveCard,
    selectedCard,
    nonce,
    chargeVerificationDetails,
    verificationToken,
    verificationLocationId,
    skipPayment = false,
    cb
  } = action?.paymentConfig;
  const store = yield select();
  const giftVoucherData = store.orders.giftVoucherData;
  const eventOrderData = getEventOrderData();
  if (!skipPayment && !selectedCard) {
    yield put(showToast('Please select a card to proceed.', 'warning'));
    return;
  }
  yield call(loading, function* () {
    if (moment().isAfter(moment(Basket.uber_expiry)) && getConfig().flags.hasUberDriverBooking && Basket.order_type.includes('delivery')) {
      const success = yield call(bookUberDriverWorker);
      if (!success) {
        return
      }
    }
    let orderData = Basket.parseBasketData(paymentType, paymentWebType);
    const store = yield select();
    if (getConfig().general.validationConfig?.mobile && store?.profile?.auth?.loggedIn) {
      const mobileValid = isEmptyObject(validateForm({ mobile: { required: true, type: 'tel' } }, { mobile: orderData.mobile }))
      if (getConfig().flags.hasMobileCountryCode) {
        if (orderData.mobile == orderData.mobile_code || !orderData.mobile || orderData.mobile == '' || !mobileValid) {
          forwardTo('/order-summary', { mobileInvalid: true })
          return
        }
      } else {
        if (!orderData.mobile || orderData.mobile == '' || !mobileValid) {
          forwardTo('/order-summary', { mobileInvalid: true })
          return
        }
      }
    }
    if (!orderData.table_name && Basket.order_type.toLowerCase() == 'table') {
      yield put({ type: SET_COMMON_PROP, key: 'tableNumberModalOpened', value: true });
      yield take('CONFIRM_TABLE_NUMBER');
      const tableNumber = Basket.getTableNumber();
      orderData.table_name = tableNumber;
    }
    orderData.paymentToken = nonce;
    orderData.payment_token = nonce;
    try {
      if (saveCard) {
        const savedCard = yield call(api.createSquarePaymentCard, { nonce: nonce, card: selectedCard, verificationToken });
        orderData.paymentToken = savedCard?.id;
        orderData.payment_token = savedCard?.id;
      }
    } catch (error) {
      console.error('Square Pay Error:', error?.response?.data);
      yield put(showToast(error?.response?.data?.error?.message || "Error adding payment card.", 'danger'));
      return;
    }
    if (Number(chargeVerificationDetails?.amount) > 0 && !skipPayment && orderData.payment_token) {
      // Square does not put a charge through 3D Secure unless the buyer was verified for it.
      try {
        if (Capacitor.getPlatform() === 'web') {
          // Saved card: pay with a verified token instead of the card ID.
          const verified = yield call([CapSquarePayments, 'verifyCardOnFile'], {
            cardId: orderData.payment_token,
            verificationDetails: chargeVerificationDetails,
          });
          orderData.paymentToken = verified.nonce;
          orderData.payment_token = verified.nonce;
        } else {
          // Native: the verification token is sent alongside the nonce or card ID.
          const chargeVerificationToken = yield call(verifySquareBuyerNative, {
            sourceId: orderData.payment_token,
            locationId: verificationLocationId,
            verificationDetails: chargeVerificationDetails,
          });
          if (chargeVerificationToken) {
            orderData.verification_token = chargeVerificationToken;
          }
        }
      } catch (error) {
        console.error('Square card verification error:', error);
        yield put(showToast('Card verification failed. Please try again or use another card.', 'danger'));
        return;
      }
    }
    let result;
    try {
      result = yield call(api.createSquareOrder, orderData);
    } catch (error) {
      // The order can go through while its confirmation is lost (timeout, dropped
      // connection). Ask the backend whether this basket was already placed and, if
      // so, carry on exactly as if the confirmation had arrived.
      let placedOrder = null;
      try {
        placedOrder = (yield call(api.getOrderByUuid, orderData.uuid))?.order;
      } catch (lookupError) {
        console.error('Order lookup by uuid failed:', lookupError);
      }
      if (!placedOrder) {
        throw error;
      }
      result = { data: { order: placedOrder, client_secret: `${placedOrder.id}` } };
    }
    Basket.rotateUUID();

    if (giftVoucherData) {
      giftVoucherData.order_id = result.data.order.id;
    }
    if (eventOrderData) {
      // ties the issued tickets back to the order that was actually paid for
      eventOrderData.order_id = result.data.order.id;
    }
    yield put({ type: GET_VOUCHERS });
    if (result.data?.error || result.error) {
      if (result.data?.type === 'insufficient_stock') {
        if (result?.data?.items.length > 0) {
          yield put({ type: SET_COMMON_MODAL, modal: 'insuficientStockModalOpened', value: true });
          Basket.setInsuficientStockData(result?.data?.items)
        }
      } else if (result.data?.type === 'order-type-unavailable') {
        yield put(showToast(result.data?.message || 'This order type is currently unavailable at this location.', 'warning'));
        if (Basket.has_multi_basket && result.data?.closed_restaurants?.length > 0) {
          const closedIds = result.data.closed_restaurants.map((r) => r.id);
          const allVenuesClosed = Basket.multi_basket_items.every((group) => closedIds.includes(group.restaurant.id));
          if (allVenuesClosed) {
            Basket.reset();
            forwardTo('/delivery-options');
          } else {
            Basket.removeRestaurantItems(closedIds);
            forwardTo('/order-summary');
          }
        } else {
          Basket.reset();
          forwardTo('/delivery-options');
        }
      }
      else if (result.data?.type === 'collection-time') {
        const restaurants = yield call(api.getRestaurants);
        yield put({
          type: SET_RESTAURANT_PROP,
          key: 'restaurants',
          value: restaurants,
        });
        yield put({ type: SET_COMMON_MODAL, modal: 'deliveryTimeModalOpen', value: true });
      } else {
        yield put(showToast('Order create error', 'warning'));
      }
    } else if (paymentType === 'collectedPay' || paymentType == 'driverPay') {
      const createdOrder = result.data.order;
      const store = yield select();
      yield put({
        type: SET_ORDERS_PROP,
        key: 'orderHistory',
        value: [createdOrder, ...(store.orders.orderHistory || [])],
      });
      yield call(resetBasket);
    } else {
      const createdOrder = result.data.order;
      const clientSecret = result.data.client_secret;
      if (!clientSecret || clientSecret === '') {
        yield put(showToast('Payment error.', 'danger'));
      } else {
        if (getConfig().payment === 'judopay') {
          if (clientSecret.result && clientSecret.result === 'Declined') {
            yield put(showToast('Payment error.\n' + (clientSecret.message || ''), 'danger'));
          } else {
            yield call(resetBasket, giftVoucherData, false, eventOrderData);
            if (giftVoucherData) {
              yield put({
                type: SEND_GIFT_VOUCHER,
                data: giftVoucherData,
              });
            }
            if (eventOrderData) {
              yield put({ type: PURCHASE_EVENT, data: eventOrderData });
            }
          }
        } else {
          if (clientSecret === '-1') {
            // total for order is: 0
            yield call(checkIntentResult, {
              status: 'succeeded',
              isValid: true
            });
            yield call(resetBasket, giftVoucherData, false, eventOrderData);
            if (giftVoucherData) {
              yield put({
                type: SEND_GIFT_VOUCHER,
                data: giftVoucherData,
              });
            }
            if (eventOrderData) {
              yield put({ type: PURCHASE_EVENT, data: eventOrderData });
            }
          } else {
            try {
              let intentResult;
              if (paymentType === 'google') {
                // pay with google pay
                intentResult = yield call(
                  LibStripe.payWithGooglePay,
                  clientSecret,
                  orderData._total,
                );
                yield call(updatePaymentInfo, intentResult, paymentType, createdOrder);
                const checkedIntentResult = yield call(checkIntentResult, intentResult);
                if (checkedIntentResult.isValid) {
                  if (giftVoucherData) {
                    yield put({
                      type: SEND_GIFT_VOUCHER,
                      data: giftVoucherData,
                    });
                  }
                  if (eventOrderData) {
                    yield put({ type: PURCHASE_EVENT, data: eventOrderData });
                  }
                  yield call(resetBasket, giftVoucherData, false, eventOrderData);
                }
              } else if (paymentType === 'apple') {
                // pay with apple pay
                const store = yield select();
                intentResult = yield call(
                  LibStripe.payWithApplePay,
                  clientSecret,
                  store.profile.profile,
                );
                yield call(updatePaymentInfo, intentResult, paymentType, createdOrder);
                const checkedIntentResult = yield call(checkIntentResult, intentResult);
                yield call(resetBasket, giftVoucherData, false, eventOrderData);

                if (giftVoucherData && checkedIntentResult.isValid) {
                  yield put({
                    type: SEND_GIFT_VOUCHER,
                    data: giftVoucherData,
                  });
                }
                if (eventOrderData && checkedIntentResult.isValid) {
                  yield put({ type: PURCHASE_EVENT, data: eventOrderData });
                }
              } else {
                yield call(resetBasket, giftVoucherData, false, eventOrderData);
                if (eventOrderData) {
                  yield put({ type: PURCHASE_EVENT, data: eventOrderData });
                }
                if (giftVoucherData) {
                  yield put({
                    type: SEND_GIFT_VOUCHER,
                    data: giftVoucherData,
                  });
                }
              }
            } catch (e) {
              console.log('Square Payment Error:', e);
              yield put(showToast('Payment error.\n' + (e.message || ''), 'danger'));
            }
          }
        }
      }
      const store = yield select();
      createdOrder.order_value = orderData.total;
      yield put({
        type: SET_ORDERS_PROP,
        key: 'orderHistory',
        value: [createdOrder, ...(store.orders.orderHistory || [])],
      });
    }
  });

  if (saveCard) {
    try {
      yield put(getPaymentCards());
    } catch (error) {
      console.error('Error fetching payment cards after saving card:', error);
    }
  }
};

// Polls the order until the checkout.com webhook flips its status.
// "paid" is authoritative ONLY from the webhook — never assume success from
// the create response or the 3DS redirect alone. The webhook sets is_paid and
// status PAID together; is_paid is the signal to trust because a multi-basket
// parent moves on to PREPARING seconds later, as soon as the split worker runs.
const pollCheckoutOrderStatus = function* (orderId, maxAttempts = 45) {
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    yield delay(2000);
    try {
      const order = yield call(api.getLastOrder, orderId.toString());
      const status = (order?.status || '').toLowerCase();
      // Failure first: a stale is_paid flag must not mask a failed/cancelled status.
      if (status.includes('failed') || status.includes('cancel')) {
        return { result: 'failed', order };
      }
      if (status === 'paid' || order?.is_paid === true) {
        return { result: 'paid', order };
      }
    } catch (e) {
      console.log('Checkout order poll error:', e);
    }
  }
  return { result: 'timeout', order: null };
};

const createCheckoutPaymentOrderFlow = function* (action) {
  const {
    paymentType,
    paymentWebType,
    selectedCard,
    nonce,
    skipPayment = false,
  } = action?.paymentConfig;
  const store = yield select();
  const giftVoucherData = store.orders.giftVoucherData;
  if (!skipPayment && !selectedCard) {
    yield put(showToast('Please select a card to proceed.', 'warning'));
    return;
  }
  yield call(loading, function* () {
    if (moment().isAfter(moment(Basket.uber_expiry)) && getConfig().flags.hasUberDriverBooking && Basket.order_type.includes('delivery')) {
      const success = yield call(bookUberDriverWorker);
      if (!success) {
        return
      }
    }
    let orderData = Basket.parseBasketData(paymentType, paymentWebType);
    const store = yield select();
    if (getConfig().general.validationConfig?.mobile && store?.profile?.auth?.loggedIn) {
      const mobileValid = isEmptyObject(validateForm({ mobile: { required: true, type: 'tel' } }, { mobile: orderData.mobile }))
      if (getConfig().flags.hasMobileCountryCode) {
        if (orderData.mobile == orderData.mobile_code || !orderData.mobile || orderData.mobile == '' || !mobileValid) {
          forwardTo('/order-summary', { mobileInvalid: true })
          return
        }
      } else {
        if (!orderData.mobile || orderData.mobile == '' || !mobileValid) {
          forwardTo('/order-summary', { mobileInvalid: true })
          return
        }
      }
    }
    if (!orderData.table_name && Basket.order_type.toLowerCase() == 'table') {
      yield put({ type: SET_COMMON_PROP, key: 'tableNumberModalOpened', value: true });
      yield take('CONFIRM_TABLE_NUMBER');
      const tableNumber = Basket.getTableNumber();
      orderData.table_name = tableNumber;
    }
    orderData.paymentToken = nonce;
    orderData.payment_token = nonce;
    let result;
    try {
      result = yield call(api.createCheckoutOrderNative, orderData);
    } catch (error) {
      // 400 = payment declined ("Process payment error. Payment declined: ...")
      console.error('Checkout payment error:', error?.response?.data);
      yield put(showToast(error?.response?.data?.error?.message || 'Payment declined.', 'danger'));
      return;
    } finally {
      Basket.rotateUUID();
    }

    if (giftVoucherData) {
      giftVoucherData.order_id = result.data.order.id;
    }
    yield put({ type: GET_VOUCHERS });
    if (result.data?.error || result.error) {
      if (result.data?.type === 'insufficient_stock') {
        if (result?.data?.items.length > 0) {
          yield put({ type: SET_COMMON_MODAL, modal: 'insuficientStockModalOpened', value: true });
          Basket.setInsuficientStockData(result?.data?.items)
        }
      } else if (result.data?.type === 'order-type-unavailable') {
        yield put(showToast(result.data?.message || 'This order type is currently unavailable at this location.', 'warning'));
        if (Basket.has_multi_basket && result.data?.closed_restaurants?.length > 0) {
          const closedIds = result.data.closed_restaurants.map((r) => r.id);
          const allVenuesClosed = Basket.multi_basket_items.every((group) => closedIds.includes(group.restaurant.id));
          if (allVenuesClosed) {
            Basket.reset();
            forwardTo('/delivery-options');
          } else {
            Basket.removeRestaurantItems(closedIds);
            forwardTo('/order-summary');
          }
        } else {
          Basket.reset();
          forwardTo('/delivery-options');
        }
      }
      else if (result.data?.type === 'collection-time') {
        const restaurants = yield call(api.getRestaurants);
        yield put({
          type: SET_RESTAURANT_PROP,
          key: 'restaurants',
          value: restaurants,
        });
        yield put({ type: SET_COMMON_MODAL, modal: 'deliveryTimeModalOpen', value: true });
      } else {
        yield put(showToast(result.data?.error?.message || 'Order create error', 'warning'));
      }
    } else {
      const createdOrder = result.data.order;
      const redirectUrl = result.data.redirect_url;
      const paymentStatus = result.data.payment_status;
      let pollOrder = null;

      const finishSuccessfulOrder = function* () {
        yield call(resetBasket, giftVoucherData);
        if (giftVoucherData) {
          yield put({
            type: SEND_GIFT_VOUCHER,
            data: giftVoucherData,
          });
        }
        const store = yield select();
        // get_last_order returns a slim object: keep the full created order and only
        // overlay the settled status and the per-restaurant child orders (the create
        // response still has the basket groups as "NEW"). Before the multi-basket split
        // the slim object carries plain items without a restaurant — skip those.
        const polledItems = (pollOrder?.multi_basket_items || []).filter((el) => el && el.restaurant);
        const finalOrder = pollOrder
          ? { ...createdOrder, status: pollOrder.status, ...(polledItems.length ? { multi_basket_items: polledItems } : {}) }
          : createdOrder;
        finalOrder.order_value = orderData.total;
        yield put({
          type: SET_ORDERS_PROP,
          key: 'orderHistory',
          value: [finalOrder, ...(store.orders.orderHistory || [])],
        });
      };

      if (paymentType === 'collectedPay' || paymentType === 'driverPay' || orderData.total === 0 || skipPayment) {
        // No payment requested (pay on collection / driver / zero total) — order is done
        yield call(finishSuccessfulOrder);
        return;
      }

      let pollResult;
      let failureReason = '';
      if (redirectUrl && paymentStatus === 'Pending') {
        // 3DS challenge — rendered by the plugin (native SDK webview on iOS/Android,
        // in-app iframe modal on web). No hosted payment page.
        // Raced against webhook polling: whichever settles first wins —
        // the webhook remains the only authority for "paid".
        const checkoutPaymentConfig = getConfig()?.checkoutPayment || {};
        let raceResult = {};
        try {
          raceResult = yield race({
            threeDS: call([CapCheckoutPayments, 'handleThreeDS'], {
              challengeUrl: redirectUrl,
              successUrl: checkoutPaymentConfig.successUrl || 'https://hybridapp.co.uk/payment/success',
              failureUrl: checkoutPaymentConfig.failureUrl || 'https://hybridapp.co.uk/payment/failure',
            }),
            settled: call(pollCheckoutOrderStatus, createdOrder.id),
          });
        } catch (e) {
          console.log('3DS challenge error:', e);
          raceResult = { threeDS: { authenticated: false } };
        }

        // Close the challenge UI if it is still showing (webhook settled first)
        try {
          yield call([CapCheckoutPayments, 'dismissThreeDS']);
        } catch (e) {
          // Nothing to dismiss
        }

        if (raceResult.settled) {
          ({ result: pollResult, order: pollOrder } = raceResult.settled);
        } else if (raceResult.threeDS?.authenticated) {
          // Challenge finished on the success URL — wait for the webhook to confirm
          ({ result: pollResult, order: pollOrder } = yield call(pollCheckoutOrderStatus, createdOrder.id));
        } else {
          // Challenge window closed (failure URL, user closed it, or the result could
          // not be read) — the backend reconciles the order with checkout.com below
          pollResult = 'closed';
        }
      } else {
        // Frictionless — wait for the webhook to settle the order
        ({ result: pollResult, order: pollOrder } = yield call(pollCheckoutOrderStatus, createdOrder.id));
      }

      if (pollResult !== 'paid' && pollResult !== 'failed') {
        // No webhook yet: the backend checks the payment at checkout.com and marks the
        // order PAID / PAYMENT FAILED / CANCELED accordingly, so a charged customer
        // never ends up with a cancelled order.
        try {
          const reconciled = yield call(api.updateCheckoutOrder, { orderId: createdOrder.id });
          const reconciledStatus = (reconciled?.data?.status || '').toLowerCase();
          if (reconciledStatus.includes('failed') || reconciledStatus.includes('cancel')) {
            pollResult = 'failed';
            failureReason = reconciled?.data?.message || '';
          } else if (reconciledStatus === 'paid' || reconciled?.data?.is_paid === true) {
            pollResult = 'paid';
          } else {
            // Still authorizing — give the webhook one more polling window
            ({ result: pollResult, order: pollOrder } = yield call(pollCheckoutOrderStatus, createdOrder.id));
          }
        } catch (e) {
          console.log('Checkout order reconcile error:', e);
        }
      }

      if (pollResult === 'paid') {
        yield call(finishSuccessfulOrder);
      } else if (pollResult === 'failed') {
        // "Payment failed: Insufficient Funds" — reason comes from checkout.com via the backend
        const reason = failureReason || pollOrder?.process_message || 'Payment failed';
        yield put(showToast(reason + '. You have not been charged.', 'danger'));
      } else {
        yield put(showToast('Payment was not completed.', 'warning'));
      }
    }
  });
};

export function* orderCreationSagas() {
  yield takeLatest(CREATE_ORDER, createOrderFlow);
  yield takeLatest(CREATE_YOCO_ORDER, createYocoOrderFlow);
  yield takeLatest(CREATE_PREBUILD_PAYMENT_ORDER, createPrebuildPaymentOrderFlow);
  yield takeLatest(CREATE_SQUARE_ORDER, createSquareOrderFlow);
  yield takeLatest(SAVE_SQUARE_PAYMENT_CARD, saveSquarePaymentCardFlow);
  yield takeLatest(CREATE_CHECKOUT_PAYMENT_ORDER, createCheckoutPaymentOrderFlow);
}
export const updatePaymentInfoFlow = function* () {
  while (true) {
    const action = yield take(UPDATE_PAYMENT_INFO);
    yield call(loading, function* () {
      const { paymentInfo } = action;
      const updatedOrder = yield call(api.updatePaymentInfo, paymentInfo);
      const store = yield select();
      let orderHistory = store.orders.orderHistory;
      const index = orderHistory.findIndex((i) => i.id === updatedOrder.id);
      if (index !== -1) {
        orderHistory[index] = updatedOrder;
      } else {
        orderHistory = [updatedOrder, ...orderHistory];
      }
      yield put({ type: SET_ORDERS_PROP, key: 'orderHistory', value: orderHistory });
    });
  }
};

const getOrderHistoryData = function* (page) {
  const orderHistory = yield call(api.getOrderHistory, page);
  let previousOrderHistory = page > 1 ? yield select((state) => state.orders.orderHistory) : [];
  yield put({ type: SET_ORDERS_PROP, key: 'orderHistory', value: [...previousOrderHistory, ...orderHistory] });
};

export const getOrderHistoryFlow = function* () {
  while (!getConfig().flags) {
    yield delay(100);
  }
  const { disableHistoryPagination } = getConfig().flags;
  while (true) {
    const action = yield take(GET_ORDER_HISTORY);
    const loading = isDefined(action.loading) ? action.loading : true;
    const page = disableHistoryPagination ? null : 1;
    if (loading) {
      yield call(loading, function* () {
        yield call(getOrderHistoryData, page);
      });
    } else {
      yield call(getOrderHistoryData, page);
    }
  }
};


export const addDeliveryAddressFlow = function* () {
  while (true) {
    const action = yield take(ADD_DELIVERY_ADDRESS);
    const { deliveryAddress, flag } = action;
    yield call(loading, function* () {
      try {
        const address = yield call(api.addDeliveryAdress, deliveryAddress);
        yield put({ type: SET_DELIVERY_ADDRESS, deliveryAddress: JSON.parse(address.config.data) });
        // yield put(showToast(yield call(translateSaga, 'Address added successfully'), 'success'));
        yield put({ type: GET_PROFILE });
        // if (!flag) {
        //   yield call(forwardTo, '/delivery-time');
        // }
      } catch (e) {
        yield put(showToast('Add address.\n' + (e.message || ''), 'danger'));
      }
    });
  }
};

export const postCodeCheckFlow = function* () {
  while (true) {
    const action = yield take(POSTCODE_CHECK);
    const { postcode } = action;
    yield call(loading, function* () {
      try {
        const checkedCodeData = yield call(api.postCodeCheck, { postcode });
        yield put({ type: SET_POSTCODE_DATA, checkedCodeData });
        if (checkedCodeData.data.length < 1) {
          yield put(showToast(yield call(translateSaga, 'No location found'), 'warning'));
        }
      } catch (e) {
        yield put({ type: SET_POSTCODE_DATA, checkedCodeData: { data: {} } });
      }
    });
  }
};

export const getNearestLocationFlow = function* () {
  while (true) {

    const action = yield take(GET_NEAREST_LOCATION);
    yield put({ type: SET_COMMON_PROP, key: 'nearestLocationsFetchingStarted', value: true });

    const { postcode, charter_delivery, scheduled_delivery } = action;
    yield call(loading, function* () {
      try {
        const checkedCodeData = yield call(api.getNearestLocation, { postcode, charter_delivery, scheduled_delivery });
        yield put({ type: SET_POSTCODE_DATA, checkedCodeData });
        if (checkedCodeData.data.length < 1) {
          yield put(showToast(yield call(translateSaga, 'No location found'), 'warning'));
        }
        yield put({ type: SET_COMMON_PROP, key: 'nearestLocationsFetchingStarted', value: false });

      } catch (e) {
        yield put({ type: SET_POSTCODE_DATA, checkedCodeData: { data: {} } });
        yield put({ type: SET_COMMON_PROP, key: 'nearestLocationsFetchingStarted', value: false });

      }
    });
  }
};


export const locationCodeCheckFlow = function* () {
  while (true) {
    const action = yield take(LOCATION_CODE_CHECK);
    const { locationCode } = action;
    try {
      const checkedLocationCodeData = yield call(api.locationCodeCheck, {
        location_code: locationCode,
      });
      yield put({ type: SET_LOCATION_CODE_DATA, checkedLocationCodeData });
    } catch (e) {
      yield put({ type: SET_LOCATION_CODE_DATA, checkedLocationCodeData: { data: [] } });
    }
  }
};

export const addPickupPointFlow = function* () {
  while (true) {
    const action = yield take(ADD_PICKUP_POINT);
    const { pickUpPoint, code } = action;
    yield call(loading, function* () {
      try {
        const point = yield call(api.addPickupPoint, { restaurant_id: pickUpPoint, code });
        let parsedData = JSON.parse(point.config.data);
        yield put({ type: SET_PICK_UP_POINT, pickUpPoint: parsedData.code });
        yield put(
          showToast(yield call(translateSaga, 'Pickup point added successfully'), 'success'),
        );
        yield put({ type: GET_PROFILE });
        yield call(forwardTo, '/delivery-time');
      } catch (e) {
        yield put(showToast('Add address.\n' + (e.message || ''), 'danger'));
      }
    });
  }
};

export const removeDeliveryAddressFlow = function* () {
  while (true) {
    const action = yield take(REMOVE_DELIVERY_ADDRESS);
    yield put({ type: SET_ORDERS_PROP, key: 'removeAddressModal', value: false });
    yield call(loading, function* () {
      const { index, order_type } = action;
      const data = {
        id: index,
        orderType: order_type,
      };
      const result = yield call(api.removeDeliveryAddress, data);
      if (result.error) {
        yield put(showToast(yield call(translateSaga, result.error.message), 'warning'));
      } else {
        yield put(
          showToast(yield call(translateSaga, 'Delivery address removed successfully'), 'success'),
        );
      }
      yield put({ type: GET_PROFILE });
    });
  }
};

export const checkCancelOrderFlow = function* () {
  while (true) {
    const action = yield take(CHECK_CANCEL_ORDER);
    yield put({ type: SET_ORDERS_PROP, key: 'cancelOrderModal', value: false });
    yield call(loading, function* () {
      const { orderId, restaurantId } = action;
      const data = {
        order_id: orderId,
        restaurant_id: restaurantId,
      };
      yield call(api.cancelOrder, data);
      yield put(showToast(yield call(translateSaga, 'Order successfully refunded'), 'success'));
    });
  }
};

export const storeWebItemFlow = function* () {
  while (true) {
    const action = yield take(STORE_ITEM_WEB);
    yield put({ type: SET_ORDERS_PROP, key: 'storedItemWeb', value: action.item });

    if (action.cb) {
      yield call(action.cb);
    }
  }
};
export const sendGiftVoucherFlow = function* () {
  while (true) {
    const action = yield take(SEND_GIFT_VOUCHER);
    yield call(loading, function* () {
      const result = yield call(api.sendGiftVoucher, action.data);
      if (!result.error) {
        forwardTo('/gift-voucher', { voucher: action.data, voucherCreated: true });
        yield put({ type: CLEAR_GIFT_VOUCHER_DATA });
        yield put({ type: GET_SENT_GIFT_VOUCHERS });
      }
    });
  }
};
export const resendGiftVoucherFlow = function* () {
  while (true) {
    const action = yield take(RESEND_GIFT_VOUCHER);
    yield call(loading, function* () {
      const result = yield call(api.resendGiftVoucher, action.data);
      if (result.error) {
        yield put(showToast(yield call(translateSaga, result.error.message), 'warning'));
      } else {
        yield put(showToast(yield call(translateSaga, result.message || result.data?.message || 'Gift voucher resent successfully'), 'success'));
        forwardTo('/sent-vouchers', { giftVoucherRedeemed: true });
        yield put({ type: CLEAR_GIFT_VOUCHER_DATA });
        yield put({ type: GET_SENT_GIFT_VOUCHERS });
      }
    });
  }
};
export const updateGiftVoucherFlow = function* () {
  while (true) {
    const action = yield take(UPDATE_GIFT_VOUCHER);
    yield call(loading, function* () {
      const result = yield call(api.updateGiftVoucher, action.data);
      if (result.error) {
        yield put(showToast(yield call(translateSaga, result.error.message), 'warning'));
      } else {
        yield put(showToast(yield call(translateSaga, result.message || result.data?.message || 'Gift voucher updated successfully'), 'success'));
        forwardTo('/sent-vouchers', { giftVoucherUpdated: true });
        yield put({ type: CLEAR_GIFT_VOUCHER_DATA });
        yield put({ type: GET_SENT_GIFT_VOUCHERS });
      }
    });
  }
};
export const redeemGiftVoucherFlow = function* () {
  while (true) {
    const action = yield take(REDEEM_GIFT_VOUCHER);
    yield call(loading, function* () {
      const result = yield call(api.redeemGiftVoucher, action.data);
      if (!result.error) {
        // forwardTo('/gift-vouchers', { giftVoucherRedeemed: true });
        yield put({
          type: 'SET_REDEEMED_GIFT_VOUCHER',
          value: result.data,
        });
      }
    });
  }
};
export const getSentGiftVouchersFlow = function* () {
  while (true) {
    yield take(GET_SENT_GIFT_VOUCHERS);
    yield call(loading, function* () {
      let result = yield call(api.getSentGiftVouchers);
      result.sort((a, b) => b.id - a.id);
      yield put({
        type: 'SET_SENT_GIFT_VOUCHERS',
        value: result,
      });
    });
  }
};

export const setTablePayMethodFlow = function* () {
  while (true) {
    const action = yield take(SET_TABLE_PAY_METHOD);

    yield call(loading, function* () {
      const { pay_method, table_bill_id, total_members_to_pay = 0 } = action.data;
      const response = yield call(api.setTablePayMethod, {
        pay_method,
        table_bill_id,
        total_members_to_pay,
      });
      yield put({
        type: SET_TABLE_DATA,
        key: 'tableData',
        value: JSON.parse(JSON.stringify(response.data.table)),
      });
      Basket.setBillPayData(response.data.table);

      if (response.data.table.pay_method == 0) {
        // const store = yield select();
        // let profile = store.profile.profile;
        // if (response.data.table.lead_user != profile) {
        //   yield call(forwardTo, '/table-opened');
        // } else {
        Basket.setTablePaymentAmount(response.data.table.total_due);
        yield call(forwardTo, '/table-overview');
        // }
      } else if (response.data.table.pay_method == 1) {
        yield call(forwardTo, '/split-bill');
      } else if (response.data.table.pay_method == 2) {
        Basket.setTablePaymentAmount(response.data.table.total_due);
        yield call(forwardTo, '/split-bill-by-amount');
      } else if (response.data.table.pay_method == 3) {
        yield call(forwardTo, '/split-bill-by-items');
      } else {
        yield call(forwardTo, '/pay-table');
      }
    });
  }
};

export const selectTableItemsFlow = function* () {
  while (true) {
    const action = yield take(SELECT_TABLE_ITEM);
    yield call(loading, function* () {
      const { tableNumber, businessLocationId, selected_item, profileId } = action.data;
      const response = yield call(api.postSlectItems, tableNumber, businessLocationId, {
        selected_item,
      });
      Basket.setBillPayData(response);
      yield put({
        type: SET_TABLE_DATA,
        key: 'tableData',
        value: JSON.parse(JSON.stringify(response)),
      });
      Basket.calculateItemsPrice(profileId);
    });
  }
};
export const sendTablePaymentEmailFlow = function* () {
  while (true) {
    const action = yield take(SEND_TABLE_PAYMENT_EMAIL);
    yield call(loading, function* () {
      const response = yield call(api.sendTablePaymentEmail, action.data);
      if (response.status === 'OK') {
        yield put({ type: SET_COMMON_PROP, key: 'paymentEmailSent', value: true });
        yield put(showToast('Payment Confirmation Email has been sent.', 'success'));
      }
    });
  }
};
export const sendTableBillFlow = function* () {
  while (true) {
    const { paymentType, paymentWebType, cb } = yield take(SEND_TABLE_BILL);
    yield call(loading, function* () {
      try {
        let billData = Basket.parseBillPayload(paymentType, paymentWebType);
        yield call(asyncStorage.setItem, 'bill_data', JSON.stringify(billData));
        const result = yield call(api.payTable, billData);
        let checkedIntentResult;
        let intentResult;

        if (result.error) {
          yield put(showToast(`${result.error.message ? result.error.message : 'Order create error'}`, 'warning'));
          forwardTo('/table-bill-pay', { completedTableOrder: false });
          return;
        } else {
          const tableData = result.data.table;
          const clientSecret = result.data.client_secret;
          const tablePaymentDataId = result.data.table_payment_uuid;
          yield call(asyncStorage.setItem, 'table_payment_data', JSON.stringify(tablePaymentDataId));
          // if (!clientSecret || clientSecret === '') {
          // 	yield put(showToast('Payment error.', 'danger'));
          // } else {
          // 	if (clientSecret === '-1') {
          // 		// total for order is: 0
          // 		intentResult = yield call(
          // 			checkIntentResult,
          // 			{
          // 				status: 'succeeded',
          // 			},
          // 			true,
          // 		);
          // 		yield call(resetBasket, false, true);
          // 	} else if (paymentType === 'webPayment') {
          // 		yield put({ type: SET_ORDERS_PROP, key: 'clientSecret', value: clientSecret });

          // 		if (cb) {
          // 			yield call(cb, clientSecret, resetBasket, false, true);
          // 		}
          // 	} else {
          // 		try {
          // 			if (paymentType === 'google') {
          // 				// pay with google pay
          // 				intentResult = yield call(Stripe.payWithGooglePay, clientSecret, billData.payment_amount + billData.service_charge_applied);
          // 				yield call(updatePaymentInfo, intentResult, paymentType, tableData);
          // 				checkedIntentResult = yield call(checkIntentResult, intentResult, true);
          // 			} else if (paymentType === 'apple') {
          // 				// pay with apple pay
          // 				const store = yield select();
          // 				intentResult = yield call(Stripe.payWithApplePay, clientSecret, store.profile.profile, true);
          // 				yield call(updatePaymentInfo, intentResult, paymentType, tableData);
          // 				checkedIntentResult = yield call(checkIntentResult, intentResult, true);
          // 			} else {
          // 				// pay with regular payment card
          // 				intentResult = yield call(Stripe.confirmPaymentIntent, clientSecret, {
          // 					paymentMethodId: billData.payment_token,
          // 				});
          // 				checkedIntentResult = yield call(checkIntentResult, intentResult, true);
          // 			}
          // 			if (checkedIntentResult && checkedIntentResult.isValid) {
          // 				yield call(resetBasket, false, true);
          // 			}
          // 			if (isDefined(intentResult) && intentResult.isValid) {
          // 				tableData.amount_paid = intentResult.intentResult.amount;
          // 				yield put({ type: SET_BILL_STATUS, billStatus: intentResult.intentResult });
          // 				yield call(forwardTo, '/bill-completed', { completedOrder: true });
          // 			}
          // 		} catch (e) {
          // 			yield put(showToast('Payment error.\n' + (e.message || ''), 'danger'));
          // 		}
          // 	}
          // }
          if (!clientSecret || clientSecret === '') {
            yield put(showToast('Payment error.', 'danger'));
          } else {
            if (getConfig().payment === 'judopay') {
              if (clientSecret.result && clientSecret.result === 'Declined') {
                yield put(showToast('Payment error.\n' + (clientSecret.message || ''), 'danger'));
              } else {
                yield call(resetBasket, false, true);
              }
            } else {
              if (clientSecret === '-1') {
                // total for order is: 0
                yield call(checkIntentResult, {
                  status: 'succeeded',
                });
                yield call(resetBasket, false, true);
              } else if (paymentType === 'webPayment') {
                yield put({ type: SET_ORDERS_PROP, key: 'clientSecret', value: clientSecret });
                if (cb) {
                  yield call(cb, clientSecret, resetBasket, false, true);
                }
              } else {
                try {
                  let intentResult;
                  if (paymentType === 'google') {
                    // pay with google pay
                    intentResult = yield call(
                      LibStripe.payWithGooglePay,
                      clientSecret,
                      billData.payment_amount + billData.service_charge_applied
                    );
                    yield call(updatePaymentInfo, intentResult, paymentType, tableData);
                    checkedIntentResult = yield call(checkIntentResult, intentResult, true);
                    if (checkedIntentResult.isValid) {
                      yield call(resetBasket, false, true);
                    }
                  } else if (paymentType === 'apple') {
                    // pay with apple pay
                    const store = yield select();
                    intentResult = yield call(
                      LibStripe.payWithApplePay,
                      clientSecret,
                      store.profile.profile,
                    );
                    yield call(updatePaymentInfo, intentResult, paymentType, tableData);
                    checkedIntentResult = yield call(checkIntentResult, intentResult, true);
                    yield call(resetBasket, false, true);

                  } else if (paymentType === 'NativePayment') {
                    const store = yield select();
                    const uuid = `${store?.profile?.profile?.id}_${Date.now()}`;
                    try {
                      const nativePayment = getConfig().nativePayment || {};
                      const merchantDisplayName = nativePayment.merchantDisplayName || "";
                      const merchantCountryCode = nativePayment.merchantCountryCode || 'GB';
                      const withZipCode = nativePayment.withZipCode || false;
                      const enableGooglePay = nativePayment.enableGooglePay || false;
                      const googlePayIsTesting = nativePayment.googlePayIsTesting || false;
                      const enableApplePay = nativePayment.enableApplePay || false;
                      const applePayMerchantId = nativePayment.applePayMerchantId || ''
                      const stripeInstance = LibStripe.getStripeInstance();
                      const customerId = result.data?.customer_id;
                      const customerEphemeralKeySecret = result.data?.ephemeral_key;
                      yield stripeInstance.createPaymentSheet({
                        GooglePayIsTesting: googlePayIsTesting,
                        paymentIntentClientSecret: clientSecret,
                        merchantDisplayName,
                        merchantCountryCode,
                        withZipCode,
                        enableGooglePay,
                        enableApplePay,
                        applePayMerchantId,
                        customerId,
                        customerEphemeralKeySecret
                      });
                      const { paymentResult } = yield stripeInstance.presentPaymentSheet();
                      if (paymentResult === 'paymentSheetCompleted') {
                        yield call(resetBasket, false, true);
                      } else {
                        Basket.setUUID(uuid, true);
                      }
                    } catch (ex) {
                      console.log('Error ', ex);
                      Basket.setUUID(uuid, true);
                    }

                  } else {
                    // pay with regular payment card
                    intentResult = yield call(LibStripe.confirmPaymentIntent, clientSecret, {
                      paymentMethodId: billData.payment_token,
                    });
                    checkedIntentResult = yield call(checkIntentResult, intentResult, true);
                    if (checkedIntentResult.isValid) yield call(resetBasket, false, true);
                    if (checkedIntentResult && checkedIntentResult.isValid) {
                      yield call(resetBasket, false, true);
                    }

                    // intentResult = yield call(api.confirmPaymentIntentNative, { intent_id: result?.data?.intent_id, payment_token: orderData.payment_token })
                    // if (intentResult && intentResult?.data?.confirmedPaymentIntent?.next_action?.use_stripe_sdk?.stripe_js) {
                    //   yield call(Browser.open, {
                    //     url: intentResult?.data?.confirmedPaymentIntent?.next_action?.use_stripe_sdk?.stripe_js,
                    //     toolbarColor: "#ffffff",
                    //     presentationStyle: 'popover',
                    //     windowName: '_self'
                    //   });
                    //   Browser.addListener('browserFinished', () => {
                    //     forwardTo('/order-completed');
                    //   });
                    // }

                  }

                  if (isDefined(intentResult) && intentResult.isValid) {
                    tableData.amount_paid = intentResult.intentResult.amount;
                    yield put({ type: SET_BILL_STATUS, billStatus: intentResult.intentResult });
                    yield call(forwardTo, '/bill-completed', { completedOrder: true });
                  }
                } catch (e) {
                  console.log(e)
                  yield put(showToast('Payment error.\n' + (e.message || ''), 'danger'));
                }
              }
            }
          }
        }
      } catch (e) {
        console.log(e)
        // yield put(showToast('Payment failed', 'danger'));
        // forwardTo('/table-bill-pay', { completedTableOrder: false });
      }
    });
  }
};
function fetchGeocoding(address) {
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
    address
  )}&key=${getEnv('GOOGLE_API_KEY')}`;
  return fetch(url).then((response) => response.json());
}
export const bookDeliveryDriverFlow = function* () {
  while (true) {
    try {
      yield take(BOOK_DELIVERY_DRIVER);
      let driverAvailable = true;

      if (!Basket.validation_id && !isEmptyObject(Basket.getDeliveryAddress())) {
        yield put({ type: SET_COMMON_PROP, key: 'driverBookingPending', value: true });
        const basketAddress = Basket.getDeliveryAddress();
        const restaurant = Basket.getRestaurant();
        const address = [basketAddress.addressLine1, basketAddress.addressLine2, basketAddress.place, basketAddress.postalCode, restaurant?.additional_delivery_settings?.deliverect?.country]
          .filter(Boolean)
          .filter((el) => el !== '')
          .join(', ');

        const store = yield select();
        const { profile } = store.profile;
        const data = {
          restaurant_id: restaurant.id,
          channelLinkId: restaurant?.additional_delivery_settings?.deliverect?.channelLinkId,
          deliveryTime: Basket.collection_time,
          packageSize: 'unknown',
          street: basketAddress.addressLine1,
          city: basketAddress.place,
          country: restaurant?.additional_delivery_settings?.deliverect?.country,
          postalCode: basketAddress.postalCode,
          coordinates: { coordinates: [basketAddress.lng, basketAddress.lat] },
          name: `${profile.first_name} ${profile.last_name}`,
          source: address,
          phone: profile.mobile,
        };
        const { validationId, available, price } = yield call(api.bookDriver, data);
        driverAvailable = available;
        if (driverAvailable) {
          Basket.setAdditionalAddressData({
            streetNumber: basketAddress.streetNumber,
            street: basketAddress.street,
            city: basketAddress.place,
          });
          Basket.setDeliverectData({
            validation_id: validationId,
            channel_link_id: restaurant.additional_delivery_settings.deliverect.channelLinkId,
            channel_name: restaurant.additional_delivery_settings.deliverect.channelName,
          });
          if (price >= 0) {
            Basket.setDeliveryPrice(price / 100);
          }
          yield put({ type: SET_COMMON_PROP, key: 'driverBookingPending', value: false });
          yield put({ type: SET_COMMON_PROP, key: 'driverBookingMessage', value: true });
          yield delay(2000);
          yield put({ type: SET_COMMON_PROP, key: 'driverBookingMessage', value: false });
        } else {
          yield put({
            type: SET_COMMON_MODAL,
            modal: 'driverUnavailableModal',
            value: true,
          });
        }
      }
      const driverCountdown = yield call(asyncStorage.getItem, 'driver_countdown');
      let remainingTime = driverCountdown ? driverCountdown : getConfig().flags.driverCountdown ? getConfig().flags.driverCountdown * 60 : 10 * 60;
      const timerTask = yield fork(timer, remainingTime);
      if (!driverAvailable) {
        yield cancel(timerTask);
        yield call(asyncStorage.removeItem, 'driver_countdown', remainingTime);
        yield put(updateDriverCountdown(0));
        Basket.setDeliverectData({
          validation_id: null,
          channel_link_id: null,
          channel_name: null,
        });
      }
    }
    catch (err) {
      yield put({ type: SET_COMMON_PROP, key: 'driverBookingPending', value: false });

    }
  }
};
function* timer(initialTime) {
  let remainingTime = initialTime;
  while (remainingTime > 0) {
    yield put(updateDriverCountdown(remainingTime));
    yield call(asyncStorage.setItem, 'driver_countdown', remainingTime);
    yield delay(1000);
    remainingTime -= 1;
  }
  yield put(updateDriverCountdown(0));
  yield call(asyncStorage.removeItem, 'driver_countdown', remainingTime);
  yield call(driverCallback);
}
function* driverCallback() {
  Basket.setDeliverectData({
    validation_id: null,
    channel_link_id: null,
    channel_name: null,
  });

  yield put({ type: BOOK_DELIVERY_DRIVER });
}
export function* bookUberDriverWorker() {
  try {
    if (!isEmptyObject(Basket.getDeliveryAddress())) {

      const basketAddress = Basket.getDeliveryAddress();
      const restaurant = Basket.getRestaurant();
      if (Basket.is_asap) {
        const currentDT = moment().tz(getConfig().timezone);
        if (restaurant && isDefined(restaurant.charter_delivery_order_slot_lead_time) && Basket.shouldAddPrepTime()) {
          currentDT.add(restaurant.charter_delivery_order_slot_lead_time, 'minutes');
        }
        Basket.setCollectionTime(currentDT)
      }

      const data = {
        restaurant_id: restaurant.id,
        deliveryTime: Basket.collection_time,
        coordinates: {
          lat: basketAddress.lat,
          lng: basketAddress.lng
        },
        address: [basketAddress.addressLine1, basketAddress.addressLine2].filter(Boolean).join(', '),
        city: basketAddress.place,
        state: restaurant?.additional_delivery_settings?.deliverect?.country,
        zip_code: basketAddress.postalCode,
      };

      const result = yield call(api.bookUberDriver, data);
      if (result.error) {
        throw result.error;
      }
      const { id, expires } = result.data;
      Basket.setUberDriverData({
        validation_id: id,
        expiry_time: expires
      });

    }
    return true;
  } catch (err) {
    console.log(err)
    yield put({
      type: SET_COMMON_MODAL,
      modal: 'driverUnavailableModal',
      value: true,
    });

    return false;
  }
}


export const bookUberDriverFlow = function* () {
  while (true) {
    try {
      yield take(BOOK_UBER_DRIVER);
      if (!Basket.validation_id && !isEmptyObject(Basket.getDeliveryAddress())) {
        yield put({ type: SET_COMMON_PROP, key: 'driverBookingPending', value: true });
        const basketAddress = Basket.getDeliveryAddress();
        const restaurant = Basket.getRestaurant();
        const address = [basketAddress.addressLine1, basketAddress.addressLine2, basketAddress.place, basketAddress.postalCode, restaurant?.additional_delivery_settings?.deliverect?.country]
          .filter(Boolean)
          .filter((el) => el !== '')
          .join(', ');

        const store = yield select();
        const { profile } = store.profile;

        const data = {
          "restaurant_id": restaurant.id,
          "deliveryTime": Basket.collection_time,
          "coordinates": {
            "lat": basketAddress.lat,
            "lng": basketAddress.lng
          },
          "address": [basketAddress.addressLine1, basketAddress.addressLine2].filter(Boolean).join(', '),
          "city": basketAddress.place,
          "state": restaurant?.additional_delivery_settings?.deliverect?.country,
          "zip_code": basketAddress.postalCode,
        }

        const result = yield call(api.bookUberDriver, data);

        if (!result.error) {
          const { id, fee, expires } = result.data
          Basket.setUberDriverData({
            validation_id: id,
            expiry_time: expires
          });
          if (fee > 0 && parseFloat(Basket._getDeliveryPrice()) == 0) {
            Basket.setDeliveryPrice(fee / 100);
          }
          yield put({ type: SET_COMMON_PROP, key: 'driverBookingPending', value: false });
          yield put({ type: SET_COMMON_PROP, key: 'driverBookingMessage', value: true });
          yield delay(2000);
          yield put({ type: SET_COMMON_PROP, key: 'driverBookingMessage', value: false });
        } else {
          yield put({
            type: SET_COMMON_MODAL,
            modal: 'driverUnavailableModal',
            value: true,
          });
        }
      }

    } catch (err) {
      yield put({
        type: SET_COMMON_MODAL,
        modal: 'driverUnavailableModal',
        value: true,
      });
      yield put({ type: SET_COMMON_PROP, key: 'driverBookingPending', value: false });

    }
  }

}

/* events Sagas */
export const getEventsFlow = function* () {
  while (true) {
    const { filters, page } = yield take(GET_EVENTS);
    yield call(loading, function* () {
      const events = yield call(api.getEvents, filters, page);
      yield put({ type: SET_EVENTS, value: events, page: page || 1 });
    });
  }
};

export const getEventCategoriesFlow = function* () {
  while (true) {
    yield take(GET_EVENT_CATEGORIES);
    yield call(loading, function* () {
      const categories = yield call(api.getEventCategories);
      yield put({ type: SET_EVENT_CATEGORIES, value: categories });
    });
  }
};

export const syncBasketWithEvent = function* (event) {
  if (!event || !event.id || !Basket.isEvent()) {
    return;
  }
  const tiers = (event.ticket_tiers || []).filter((tier) => tier.is_active);
  const items = Basket.getItems();
  let unavailable = false;
  let priceChanged = false;
  let maxChanged = false;
  for (let index = items.length - 1; index >= 0; index--) {
    const basketItem = items[index];
    if (String(basketItem.item?.event_id) !== String(event.id)) {
      continue;
    }
    const tier = tiers.find((activeTier) => activeTier.id === basketItem.item.ticket_tier_id);
    if (!tier || tier.is_sold_out) {
      yield call(Basket.changeItemQuantity, index, 0);
      unavailable = true;
      continue;
    }
    const productPrice = (tier.price / 100).toFixed(2);
    if (basketItem.item.productPrice !== productPrice) {
      basketItem.item.productPrice = productPrice;
      priceChanged = true;
    }
    const perOrder = tier.max_per_order || 0;
    const available = tier.available_quantity != null ? tier.available_quantity : perOrder;
    const maxQuantity = Math.min(perOrder, available);
    if (basketItem.item.max_quantity !== maxQuantity) {
      basketItem.item.max_quantity = maxQuantity;
      maxChanged = true;
    }
    const eventMaxQuantity = event.max_tickets_per_order || 0;
    if (basketItem.item.event_max_quantity !== eventMaxQuantity) {
      basketItem.item.event_max_quantity = eventMaxQuantity;
      maxChanged = true;
    }
    if (tier.available_quantity != null && basketItem.quantity > tier.available_quantity) {
      yield call(Basket.changeItemQuantity, index, tier.available_quantity);
      unavailable = true;
    }
  }
  if (priceChanged || maxChanged) {
    Basket.instanceStateChanged();
  }
  if (unavailable) {
    yield put(
      showToast(
        yield call(
          translateSaga,
          'Some tickets in your basket are no longer available. Your basket has been updated.',
        ),
        'warning',
      ),
    );
  } else if (priceChanged) {
    yield put(
      showToast(
        yield call(translateSaga, 'Ticket prices have changed. Your basket has been updated.'),
        'warning',
      ),
    );
  }
  if (unavailable && ['/checkout', '/order-summary'].indexOf(window.location.pathname) !== -1) {
    forwardTo('/event-tickets', { event });
  }
};

export const getEventFlow = function* () {
  while (true) {
    const { idOrSlug, skipLoading, skipStore } = yield take(GET_EVENT);
    const saga = function* () {
      const event = yield call(api.getEvent, idOrSlug);
      if (!skipStore) {
        yield put({ type: SET_EVENT, value: event });
      }
      yield call(syncBasketWithEvent, event);
    };
    // background refreshes (firebase) must not flash the global spinner
    if (skipLoading) {
      yield call(saga);
    } else {
      yield call(loading, saga);
    }
  }
};

const myEventsFlow = (getType, setType, bucket) =>
  function* () {
    while (true) {
      const { page } = yield take(getType);
      yield call(loading, function* () {
        const result = yield call(api.getMyEvents, bucket, page);
        yield put({ type: setType, value: result, page: page || 1 });
      });
    }
  };

export const getMyEventsCurrentFlow = myEventsFlow(
  GET_MY_EVENTS_CURRENT,
  SET_MY_EVENTS_CURRENT,
  'current',
);

export const getMyEventsUpcomingFlow = myEventsFlow(
  GET_MY_EVENTS_UPCOMING,
  SET_MY_EVENTS_UPCOMING,
  'upcoming',
);

export const getMyEventsHistoryFlow = myEventsFlow(
  GET_MY_EVENTS_HISTORY,
  SET_MY_EVENTS_HISTORY,
  'history',
);

export const getEventTicketFlow = function* () {
  while (true) {
    const { uuid } = yield take(GET_EVENT_TICKET);
    yield call(loading, function* () {
      const ticket = yield call(api.getEventTicket, uuid);
      yield put({ type: SET_EVENT_TICKET, value: ticket });
    });
  }
};

export const transferEventTicketFlow = function* () {
  while (true) {
    const { uuid, data, cb } = yield take(TRANSFER_EVENT_TICKET);
    yield call(loading, function* () {
      const result = yield call(api.transferEventTicket, uuid, data);
      if (!result.error) {
        yield put({ type: GET_MY_EVENTS_CURRENT, page: 1 });
        yield put({ type: GET_MY_EVENTS_UPCOMING, page: 1 });
        if (cb) {
          yield call(cb, result);
        }
      }
    });
  }
};

export const purchaseEventFlow = function* () {
  while (true) {
    const { data, cb } = yield take(PURCHASE_EVENT);
    yield call(loading, function* () {
      try {
        const result = yield call(api.purchaseEvent, data);
        if (result.error) {
          throw new Error(result.error);
        }
        yield put({ type: SET_EVENT_PURCHASE, value: result.data || result });
        // the tickets only exist once this call returns, so refresh before showing them
        yield put({ type: GET_MY_EVENTS_CURRENT, page: 1 });
        yield put({ type: GET_MY_EVENTS_UPCOMING, page: 1 });
        forwardTo('/ticket', { eventId: data.event_id, ticketsPurchased: true });
        if (cb) {
          yield call(cb, result);
        }
      } catch (error) {
        forwardTo('/events',{error:"Something went wrong. Please contact us for assistance."});
      }
    });
  }
};
export const getCuratedMenusFlow = function* () {
  while (true) {
    yield take(GET_CURATED_MENUS);
    yield call(loading, function* () {
      try {
        const curatedMenus = yield call(api.getCuratedMenus);
        yield put({ type: SET_ORDERS_PROP, key: 'curatedMenus', value: curatedMenus || [] });
      } catch (error) {
        yield put(showToast(yield call(translateSaga, 'Get curated menus error.'), 'warning'));
      }
    });
  }
};

const getCuratedMenuLocationId = (menu) => menu.business_location_id ?? menu.bussiness_location_id;

const stampCuratedMenuItems = (entries, business_location_id, ikentoo_menu_id, curated_restaurant_name) => {
  (entries || []).forEach((entry) => {
    if (entry.menuEntry) {
      stampCuratedMenuItems(entry.menuEntry, business_location_id, ikentoo_menu_id, curated_restaurant_name);
    } else if (entry.sku) {
      entry.business_location_id = business_location_id;
      entry.ikentoo_menu_id = ikentoo_menu_id;
      entry.curated_restaurant_name = curated_restaurant_name;
    }
  });
};

const mergeCuratedMenuGroups = (groups) =>
  Object.values(
    groups.reduce((merged, group) => {
      const key = (group.name || '').trim().toLowerCase();
      merged[key] = merged[key]
        ? { ...merged[key], menuEntry: [...(merged[key].menuEntry || []), ...(group.menuEntry || [])] }
        : { ...group };
      return merged;
    }, {}),
  );

const isCuratedMenuAvailable = (timeSelector, ikentooMenuId, time) =>
  timeSelector
    .filter((menu) => menu.menuId?.toString() === ikentooMenuId?.toString())
    .flatMap((menu) => getEffectiveAvailability(menu.availability, time.day()))
    .some(({ start, end }) => {
      const pickTime = moment(time.format('HH:mm'), 'HH:mm');
      return pickTime.isSameOrAfter(moment(start, 'HH:mm')) && pickTime.isSameOrBefore(moment(end, 'HH:mm'));
    });

export const buildCuratedMenuSaga = function* (menuId, orderType, collectionTime) {
  const curatedMenu = yield call(api.getCuratedMenu, menuId, orderType);
  let restaurants = yield select((state) => state.restaurants.restaurants);
  if (!restaurants?.length) {
    yield call(getRestaurantsWorker);
    restaurants = yield select((state) => state.restaurants.restaurants);
  }
  const { flag, getTimeSelector } = getOrderTypeMenus(orderType);
  const time = collectionTime ? moment(collectionTime) : moment().tz(getConfig().timezone);
  const items = [];
  (curatedMenu?.items || []).forEach((menu) => {
    const locationId = getCuratedMenuLocationId(menu);
    const restaurant = restaurants.find((restaurant) => restaurant.business_location_id == locationId);
    if (
      restaurant &&
      restaurant.is_published &&
      restaurant[flag] &&
      Basket.isRestaurantAllowed(restaurant) &&
      isStoreOpened(restaurant) &&
      isCuratedMenuAvailable(getTimeSelector(restaurant), menu.ikentooMenuId, time)
    ) {
      const filteredMenu = filterMenu(menu);
      stampCuratedMenuItems(filteredMenu.menuEntryGroups, locationId, filteredMenu.ikentooMenuId, restaurant.name);
      items.push(filteredMenu);
    }
  });
  let curatedMenus = yield select((state) => state.orders.curatedMenus);
  if (!curatedMenus?.length) {
    curatedMenus = (yield call(api.getCuratedMenus)) || [];
    yield put({ type: SET_ORDERS_PROP, key: 'curatedMenus', value: curatedMenus });
  }
  const ikentooMenu = {
    menuName: curatedMenus.find((menu) => menu.menuId === menuId)?.menuName || '',
    ikentooMenuId: `curated_${menuId}`,
    menuEntryGroups: mergeCuratedMenuGroups(items.flatMap((menu) => menu.menuEntryGroups || [])),
  };
  return { curatedMenu: { ...curatedMenu, items }, ikentooMenu };
};

export const getCuratedMenuFlow = function* () {
  while (true) {
    const { menuId, orderType, collectionTime, saveOrderData } = yield take(GET_CURATED_MENU);
    yield put({ type: SET_ORDERS_PROP, key: 'selectedCuratedMenuId', value: menuId });
    yield call(loading, function* () {
      try {
        const { curatedMenu, ikentooMenu } = yield call(buildCuratedMenuSaga, menuId, orderType, collectionTime);
        if (curatedMenu.items.length === 0) {
          yield put(showToast(yield call(translateSaga, 'No menus available for selected time.'), 'warning'));
          return;
        }
        if (!saveOrderData) {
          const deliveryOption = Basket.getDeliveryOption();
          const deliveryAddress = Basket.getDeliveryAddress();
          const deliveryPrice = Basket.restaurant_delivery_price;
          const tableNumber = Basket.getTableNumber();
          const allowedRestaurantIds = Basket.getAllowedRestaurantIds();
          Basket.reset();
          Basket.setDeliveryOption(deliveryOption);
          if (deliveryAddress) {
            Basket.setDeliveryAddress(deliveryAddress);
          }
          if (deliveryPrice) {
            Basket.setDeliveryPrice(deliveryPrice);
          }
          if (tableNumber) {
            Basket.setTableNumber(tableNumber);
          }
          Basket.setAllowedRestaurantIds(allowedRestaurantIds);
          Basket.setASAP(!collectionTime);
          Basket.setCollectionTime(collectionTime || moment());
          Basket.setOrderType(orderType || deliveryOption?.id);
          Basket.setMultiBasket();
        }
        Basket.setCuratedMenu(menuId);
        yield put({ type: SET_ORDERS_PROP, key: 'curatedMenu', value: curatedMenu });
        yield put({ type: SET_RESTAURANT_PROP, key: 'ikentooMenu', value: ikentooMenu });
        forwardTo('/order');
      } catch (error) {
        yield put({ type: SET_ORDERS_PROP, key: 'curatedMenu', value: {} });
        yield put(showToast(yield call(translateSaga, 'Get curated menu error.'), 'warning'));
      }
    });
  }
};
